import mixpanel from 'mixpanel-browser';

export const setupMixpanel = () => {
  const mixpanelToken = __JS_ENV_VARS__['JS_ENV_MIXPANEL_TOKEN'];
  mixpanel.init(mixpanelToken, { debug: true });
};

export const useMixpanel = () => {
  const track = (eventName: string, properties: Record<string, unknown>) => {
    mixpanel.track(eventName, properties);
  };

  const identify = (distinctId: string) => {
    mixpanel.identify(distinctId);
    mixpanel.people.set('User Distinct ID', distinctId);
  };

  const increaseUserPropertyValue = (key: string, value: number) => {
    mixpanel.people.increment(key, value);
  };

  const updateUserProperty = (key: string, value: unknown) => {
    mixpanel.people.set(key, value);
  };

  return {
    track,
    identify,
    increaseUserPropertyValue,
    updateUserProperty,
  };
};
